import { LocationSwitcher } from '@/components/AppLayout/LocationSwitcher';

import { SidebarMenuProps } from '@/types';

export const MobileSidebarHeader = (props: SidebarMenuProps) => {
  const { location_props, is_location_switcher_visible } = props;

  if (!is_location_switcher_visible) {
    return null;
  }

  return (
    <div className="border-sidebar-border bg-sidebar text-foreground flex flex-col gap-2 border-b p-2 pb-4">
      <LocationSwitcher {...location_props} />
    </div>
  );
};
